import { PageModel, StepModel } from '../models/private-models'
import { getText } from '../../../internal/TextLabels'
import { ApplicationStatus } from '../../../models/application-status'

export const createSteps = () => {
  return [
    {
      step: StepModel.GOVERNMENT_ID,
      label: getText('payApply.wizard.private.customer'),
    },
    {
      step: StepModel.SELECT_PAYMENT_METHOD,
      label: getText('payApply.wizard.private.selectPaymentMethod'),
    },
    {
      step: StepModel.SIGN_IDENTIFY,
      label: getText('payApply.wizard.private.signIdentify'),
    },
    {
      step: StepModel.DONE,
      label: getText('payApply.wizard.private.done'),
    },
  ]
}

export const getStepForCurrentPage = newIndex => {
  console.log('New index', newIndex) // eslint-disable-line
  switch (newIndex) {
    case PageModel.GOVERNMENT_ID:
      return StepModel.GOVERNMENT_ID
    case PageModel.PAYMENT_METHOD:
    case PageModel.PAYMENT_METHOD_FORM_SPEC:
      return StepModel.SELECT_PAYMENT_METHOD
    case PageModel.APPLICATION_SIGN:
    case PageModel.APPLICATION_INSPECTION:
    case PageModel.APPLICATION_REJECTED:
    case PageModel.APPLICATION_SUPPLEMENTING_REQUIRED:
    case PageModel.PAYMENT_SIGN:
    case PageModel.PAYMENT_IDENTIFICATION:
    case PageModel.PAYMENT_INSPECTION:
    case PageModel.PAYMENT_REJECTED:
    case PageModel.ERROR:
      return StepModel.SIGN_IDENTIFY
    case PageModel.APPLICATION_PUSHED_OUT_TO_CUSTOMER:
    case PageModel.PAYMENT_PUSHED_OUT_TO_CUSTOMER:
    case PageModel.APPLICATION_DONE:
    case PageModel.PAYMENT_DONE:
    case PageModel.SIGNING_REQUEST_SENT:
      return StepModel.DONE
    default:
      console.log('No step for current page', newIndex) // eslint-disable-line
      return null
  }
}

export const handleApplicationResult = payApply => {
  switch (payApply.application.applicationResult.status) {
    case ApplicationStatus.APPLICATION_PUSHED_OUT_TO_CUSTOMER:
      return PageModel.APPLICATION_PUSHED_OUT_TO_CUSTOMER
    case ApplicationStatus.ESKAT_REQUIRED:
    case ApplicationStatus.CUSTOMER_INTERACTION_REQUIRED:
    case ApplicationStatus.REQUIRED_FIELDS_MISSING:
      return PageModel.PAYMENT_METHOD_FORM_SPEC
    case ApplicationStatus.APPROVED:
      if (
        (payApply.application.applicationResult.application.signing
          .signingType === 'PHYSICAL' ||
          payApply.application.applicationResult.application.signing
            .signingStatus === 'SKIPPED') &&
        payApply.wizard.currentPage !== PageModel.APPLICATION_SIGN
      ) {
        return PageModel.APPLICATION_SIGN
      }
      return PageModel.APPLICATION_DONE
    case ApplicationStatus.SIGNING_REQUIRED:
    case ApplicationStatus.SESSION_ALIVE:
      return PageModel.APPLICATION_SIGN
    case ApplicationStatus.REJECTED:
      return PageModel.APPLICATION_REJECTED
    case ApplicationStatus.TIMED_OUT:
    case ApplicationStatus.ACCOUNT_CREATION_FAILED:
      return PageModel.ERROR
    case ApplicationStatus.INSPECTION:
      return PageModel.APPLICATION_INSPECTION
    case ApplicationStatus.SUPPLEMENTING_REQUIRED:
      return PageModel.APPLICATION_SUPPLEMENTING_REQUIRED
    case ApplicationStatus.FROZEN:
    case ApplicationStatus.AUTHENTICATION_REQUIRED:
    case ApplicationStatus.CUSTOMER_REDIRECTION_REQUIRED:
    case ApplicationStatus.PSP_REDIRECTION_REQUIRED:
    default:
      // eslint-disable-next-line no-console
      console.log(
        'Unsupported application status',
        payApply.application.applicationResult.status,
      )
      return null
  }
}

export const handlePaymentResult = payApply => {
  let page

  switch (payApply.payment.paymentResult.status) {
    case ApplicationStatus.PAYMENT_PUSHED_OUT_TO_CUSTOMER:
      page = PageModel.PAYMENT_PUSHED_OUT_TO_CUSTOMER
      break
    case ApplicationStatus.ESKAT_REQUIRED:
    case ApplicationStatus.PSP_REDIRECTION_REQUIRED:
      page = PageModel.PAYMENT_METHOD_FORM_SPEC
      break
    case ApplicationStatus.CUSTOMER_INTERACTION_REQUIRED:
    case ApplicationStatus.REQUIRED_FIELDS_MISSING:
      return PageModel.PAYMENT_METHOD_FORM_SPEC
    case ApplicationStatus.APPROVED:
      page = PageModel.PAYMENT_DONE
      break
    case ApplicationStatus.SIGNED:
    case ApplicationStatus.SIGNING_REQUIRED:
      page = PageModel.PAYMENT_SIGN
      break
    case ApplicationStatus.SIGNING_REQUEST_SENT:
      page = PageModel.SIGNING_REQUEST_SENT
      break
    case ApplicationStatus.AUTHENTICATION_REQUIRED:
      page = PageModel.PAYMENT_IDENTIFICATION
      break
    case ApplicationStatus.REJECTED:
      page = PageModel.PAYMENT_REJECTED
      break
    case ApplicationStatus.TIMED_OUT:
    case ApplicationStatus.ACCOUNT_CREATION_FAILED:
      page = PageModel.ERROR
      break
    case ApplicationStatus.INSPECTION:
    case ApplicationStatus.SUPPLEMENTING_REQUIRED:
      page = PageModel.PAYMENT_INSPECTION
      break
    case ApplicationStatus.REQUIRES_LOWER_PURCHASE_AMOUNT:
      page = PageModel.PAYMENT_ADJUST_PURCHASE_AMOUNT
      break
    case ApplicationStatus.SESSION_ALIVE:
    case ApplicationStatus.FROZEN:
    case ApplicationStatus.CUSTOMER_REDIRECTION_REQUIRED:
    default:
      console.log('Unsupported application status') // eslint-disable-line
      page = PageModel.ERROR
      break
  }
  return page
}
